import React from "react";
import { Anchor, Box, Paragraph } from "grommet";
import { CONTACTS } from "../../mocks/contacts";
export var ContactsItem = function ContactsItem() {
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      gap: "large",
    },
    CONTACTS.map(function (el) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          key: el.id,
          wrap: true,
          gap: "medium",
          style: {
            fontFamily: "Gotham Pro",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            gap: "small",
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "18px",
              fill: true,
              style: {
                fontWeight: "bolder",
              },
            },
            el.name
          ),
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "16px",
              fill: true,
              style: {
                fontFamily: "Gotham Pro",
              },
            },
            "\u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435: ",
            el.short_name
          )
        ),
        /*#__PURE__*/ React.createElement(
          Box,
          {
            gap: "small",
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "16px",
              fill: true,
            },
            "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0430\u0434\u0440\u0435\u0441: ",
            el.address
          ),
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "16px",
              fill: true,
            },
            "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430:",
            " ",
            /*#__PURE__*/ React.createElement(
              Anchor,
              {
                href: "mailto:" + el.email,
                style: {
                  fontWeight: "normal",
                },
                color: "#313131",
              },
              el.email
            )
          )
        )
      );
    })
  );
};
